import { LUDUM_SPORTS } from '@/constants';
const { BIKE, MOUNTAIN_BIKING, WHEELCHAIR_RACING, HAND_CYCLING, INDOOR_CYCLING, SPINNING, VIRTUAL_RIDE } = LUDUM_SPORTS;
export const CYCLING_SESSION_TYPES = [
    BIKE,
    MOUNTAIN_BIKING,
    WHEELCHAIR_RACING,
    HAND_CYCLING,
    INDOOR_CYCLING,
    SPINNING,
    VIRTUAL_RIDE
];
import get from 'get-object-path';

export const profileReportsBike = {
    namespaced: true,

    state: {
        topResults: null,
        bestParts: null,
        selectedSessions: [],
        filter: {
            tags: [],
            focuses: [],
            sessionTypes: [],
            hrIntensities: [],
            minDistance: null,
            maxDistance: null,
            minTime: null,
            maxTime: null
        }
    },

    getters: {
        sessionTypes(state, getters, rootState, rootGetters) {
            return rootGetters['clubHelper/clubSessionTypes'].filter(({ id }) => CYCLING_SESSION_TYPES.includes(id));
        },

        filter(state) {
            return state.filter;
        },

        selectedSessions(state) {
            return state.selectedSessions;
        },

        bestPartsTime(state) {
            return get(state, 'bestParts.time') || {};
        },

        topResults(state) {
            return state.topResults;
        }
    },

    mutations: {
        resetState(state) {
            state.topResults = null;
            state.bestParts = null;
            state.selectedSessions = [];
            state.filter = {
                tags: [],
                focuses: [],
                sessionTypes: [],
                hrIntensities: [],
                minDistance: null,
                maxDistance: null,
                minTime: null,
                maxTime: null
            };
        },

        selectSession(state, payload) {
            const index = state.selectedSessions.indexOf(payload.sessionId);
            if (payload.event && index === -1) {
                state.selectedSessions.push(payload.sessionId);
            } else if (!payload.event && index !== -1) {
                state.selectedSessions.splice(index, 1);
            }
        },

        setTags(state, payload) {
            state.filter.tags = payload;
        },

        setBestParts(state, payload) {
            state.bestParts = payload;
        },

        setTopResults(state, payload) {
            state.topResults = payload;
        },

        setSport(state, payload) {
            state.filter.sessionTypes = payload;
        },

        setHrIntensity(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setFocus(state, payload) {
            state.filter.focuses = payload;
        }
    }
};

export default profileReportsBike;
